module.exports = __webpack_public_path__ + "img/ecopayz.05cf88a2.png";